import React from "react";
import "../../styles/sectionPage.css";

const SectionSkeleton = () => {
  return (
    <div className="section-page-container">
      {/* Breadcrumb Skeleton */}
      <div className="breadcrumb-container" style={{ width: "200px" }}>
        <div className="skeleton-pulse" style={{ height: "14px", width: "100%", borderRadius: "4px" }}></div>
      </div>

      {/* Banner Skeleton */}
      <div className="skeleton-banner skeleton-pulse"></div>

      {/* Categories Section Title Skeleton */}
      <div style={{ width: "180px", marginBottom: "16px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "100%", borderRadius: "4px" }}></div>
      </div>

      {/* Categories Row Skeleton */}
      <div className="skeleton-categories">
        <div className="skeleton-chip skeleton-pulse"></div>
        <div className="skeleton-chip skeleton-pulse"></div>
        <div className="skeleton-chip skeleton-pulse"></div>
        <div className="skeleton-chip skeleton-pulse"></div>
        <div className="skeleton-chip skeleton-pulse"></div>
      </div>
    </div>
  );
};

export default SectionSkeleton;
